var _linearGradient, _linearGradient2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeatherbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wa",
    id: "wb",
    x1: -108.9,
    y1: 2124.8,
    x2: -1137.2,
    y2: 2110.7,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.0774 0 0 .0774 88.4 -128)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "wa"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e82f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93dcf7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9.8a21.5 21.5 0 00-18.8 11 11.8 11.8 0 00-5.1-1.2 11.8 11.8 0 00-11.6 9.9 16.3 16.3 0 00-10 15 16.3 16.3 0 0016.2 16.2 16.3 16.3 0 002-.1H64a15.1 15.2 0 00.7 0 15.1 15.2 0 00.7 0h1v-.1a15.1 15.2 0 0013.4-15v-.1a15.1 15.2 0 00-12.3-15A21.5 21.5 0 0045.9.9z",
    fill: "url(#wb)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherbit);
export default __webpack_public_path__ + "static/media/Weatherbit.708d8372.svg";
export { ForwardRef as ReactComponent };